import { parseToNearbyPharmacyMedicineVo } from '@/parsers/pharmacy';

import { useTreatmentMedicinesByTreatmentIdQuery } from './pharmacy.gql.impl';

const useTreatmentMedicinesByTreatmentId = (treatmentId: string) => {
  const { data } = useTreatmentMedicinesByTreatmentIdQuery(
    { treatmentId },
    {
      enabled: !!treatmentId,
      select: parseToNearbyPharmacyMedicineVo,
    },
  );

  return {
    data: data ?? [],
  };
};

export default useTreatmentMedicinesByTreatmentId;
